module.exports = __webpack_public_path__ + "img/67.b607f06d.jpg";